@if (canResize) {
  <div
    class="drag-container drag-area-{{ area }}"
    (mousedown)="dragStart($event)"
    (touchstart)="touchStart($event)"
  ></div>
}
<div class="drag-container-content has-drag-area-{{ area }}" [class.resize-enabled]="canResize">
  <ng-content></ng-content>
</div>
